// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/casinosconfig/casinos_config.proto (package ga.config_manager.casinosconfig, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/casinosconfig/casinos_config.proto.
 */
export const file_ga_config_manager_casinosconfig_casinos_config: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message ga.config_manager.casinosconfig.ModelsBranchesRequest
 */
export type ModelsBranchesRequest = Message<"ga.config_manager.casinosconfig.ModelsBranchesRequest"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.ModelsBranchesRequest.
 * Use `create(ModelsBranchesRequestSchema)` to create a new message.
 */
export const ModelsBranchesRequestSchema: GenMessage<ModelsBranchesRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 0);

/**
 * @generated from message ga.config_manager.casinosconfig.ModelsBranchesResponse
 */
export type ModelsBranchesResponse = Message<"ga.config_manager.casinosconfig.ModelsBranchesResponse"> & {
  /**
   * @generated from field: repeated string branches = 1;
   */
  branches: string[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.ModelsBranchesResponse.
 * Use `create(ModelsBranchesResponseSchema)` to create a new message.
 */
export const ModelsBranchesResponseSchema: GenMessage<ModelsBranchesResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 1);

/**
 * @generated from message ga.config_manager.casinosconfig.ModelsRequest
 */
export type ModelsRequest = Message<"ga.config_manager.casinosconfig.ModelsRequest"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.ModelsRequest.
 * Use `create(ModelsRequestSchema)` to create a new message.
 */
export const ModelsRequestSchema: GenMessage<ModelsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 2);

/**
 * @generated from message ga.config_manager.casinosconfig.ModelsResponse
 */
export type ModelsResponse = Message<"ga.config_manager.casinosconfig.ModelsResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.CasinoModel models = 1;
   */
  models: CasinoModel[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.ModelsResponse.
 * Use `create(ModelsResponseSchema)` to create a new message.
 */
export const ModelsResponseSchema: GenMessage<ModelsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 3);

/**
 * @generated from message ga.config_manager.casinosconfig.CasinoModel
 */
export type CasinoModel = Message<"ga.config_manager.casinosconfig.CasinoModel"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * @generated from field: string setting = 2;
   */
  setting: string;

  /**
   * @generated from field: ga.config_manager.casinosconfig.SettingType setting_type = 3;
   */
  settingType: SettingType;

  /**
   * @generated from field: string comment = 4;
   */
  comment: string;

  /**
   * @generated from field: bool required = 5;
   */
  required: boolean;

  /**
   * @generated from field: string regexp = 6;
   */
  regexp: string;

  /**
   * @generated from field: ga.config_manager.casinosconfig.Action action = 16;
   */
  action: Action;
};

/**
 * Describes the message ga.config_manager.casinosconfig.CasinoModel.
 * Use `create(CasinoModelSchema)` to create a new message.
 */
export const CasinoModelSchema: GenMessage<CasinoModel> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 4);

/**
 * @generated from message ga.config_manager.casinosconfig.Result
 */
export type Result = Message<"ga.config_manager.casinosconfig.Result"> & {
  /**
   * @generated from field: map<string, string> errors = 1;
   */
  errors: { [key: string]: string };

  /**
   * @generated from field: map<string, string> warnings = 2;
   */
  warnings: { [key: string]: string };

  /**
   * @generated from field: map<string, string> infos = 3;
   */
  infos: { [key: string]: string };
};

/**
 * Describes the message ga.config_manager.casinosconfig.Result.
 * Use `create(ResultSchema)` to create a new message.
 */
export const ResultSchema: GenMessage<Result> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 5);

/**
 * @generated from message ga.config_manager.casinosconfig.CopyModelsBranchRequest
 */
export type CopyModelsBranchRequest = Message<"ga.config_manager.casinosconfig.CopyModelsBranchRequest"> & {
  /**
   * @generated from field: string from_branch = 1;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.CopyModelsBranchRequest.
 * Use `create(CopyModelsBranchRequestSchema)` to create a new message.
 */
export const CopyModelsBranchRequestSchema: GenMessage<CopyModelsBranchRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 6);

/**
 * @generated from message ga.config_manager.casinosconfig.CopyModelsBranchResponse
 */
export type CopyModelsBranchResponse = Message<"ga.config_manager.casinosconfig.CopyModelsBranchResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.CopyModelsBranchResponse.
 * Use `create(CopyModelsBranchResponseSchema)` to create a new message.
 */
export const CopyModelsBranchResponseSchema: GenMessage<CopyModelsBranchResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 7);

/**
 * @generated from message ga.config_manager.casinosconfig.UpsertModelRequest
 */
export type UpsertModelRequest = Message<"ga.config_manager.casinosconfig.UpsertModelRequest"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.CasinoModel models = 1;
   */
  models: CasinoModel[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.UpsertModelRequest.
 * Use `create(UpsertModelRequestSchema)` to create a new message.
 */
export const UpsertModelRequestSchema: GenMessage<UpsertModelRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 8);

/**
 * @generated from message ga.config_manager.casinosconfig.UpsertModelResponse
 */
export type UpsertModelResponse = Message<"ga.config_manager.casinosconfig.UpsertModelResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.UpsertModelResponse.
 * Use `create(UpsertModelResponseSchema)` to create a new message.
 */
export const UpsertModelResponseSchema: GenMessage<UpsertModelResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 9);

/**
 * @generated from message ga.config_manager.casinosconfig.DeleteModelRequest
 */
export type DeleteModelRequest = Message<"ga.config_manager.casinosconfig.DeleteModelRequest"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * @generated from field: repeated string setting = 2;
   */
  setting: string[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.DeleteModelRequest.
 * Use `create(DeleteModelRequestSchema)` to create a new message.
 */
export const DeleteModelRequestSchema: GenMessage<DeleteModelRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 10);

/**
 * @generated from message ga.config_manager.casinosconfig.DeleteModelResponse
 */
export type DeleteModelResponse = Message<"ga.config_manager.casinosconfig.DeleteModelResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.DeleteModelResponse.
 * Use `create(DeleteModelResponseSchema)` to create a new message.
 */
export const DeleteModelResponseSchema: GenMessage<DeleteModelResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 11);

/**
 * @generated from message ga.config_manager.casinosconfig.MergeModelRequest
 */
export type MergeModelRequest = Message<"ga.config_manager.casinosconfig.MergeModelRequest"> & {
  /**
   * @generated from field: string from_branch = 1;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.MergeModelRequest.
 * Use `create(MergeModelRequestSchema)` to create a new message.
 */
export const MergeModelRequestSchema: GenMessage<MergeModelRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 12);

/**
 * @generated from message ga.config_manager.casinosconfig.MergeModelResponse
 */
export type MergeModelResponse = Message<"ga.config_manager.casinosconfig.MergeModelResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.MergeModelResponse.Delta deltas = 1;
   */
  deltas: MergeModelResponse_Delta[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.MergeModelResponse.
 * Use `create(MergeModelResponseSchema)` to create a new message.
 */
export const MergeModelResponseSchema: GenMessage<MergeModelResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 13);

/**
 * @generated from message ga.config_manager.casinosconfig.MergeModelResponse.Delta
 */
export type MergeModelResponse_Delta = Message<"ga.config_manager.casinosconfig.MergeModelResponse.Delta"> & {
  /**
   * @generated from field: string setting = 1;
   */
  setting: string;

  /**
   * @generated from field: string value_from = 3;
   */
  valueFrom: string;

  /**
   * @generated from field: string value_to = 4;
   */
  valueTo: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.MergeModelResponse.Delta.
 * Use `create(MergeModelResponse_DeltaSchema)` to create a new message.
 */
export const MergeModelResponse_DeltaSchema: GenMessage<MergeModelResponse_Delta> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 13, 0);

/**
 * @generated from message ga.config_manager.casinosconfig.SettingsBranchesRequest
 */
export type SettingsBranchesRequest = Message<"ga.config_manager.casinosconfig.SettingsBranchesRequest"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.SettingsBranchesRequest.
 * Use `create(SettingsBranchesRequestSchema)` to create a new message.
 */
export const SettingsBranchesRequestSchema: GenMessage<SettingsBranchesRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 14);

/**
 * @generated from message ga.config_manager.casinosconfig.SettingsBranchesResponse
 */
export type SettingsBranchesResponse = Message<"ga.config_manager.casinosconfig.SettingsBranchesResponse"> & {
  /**
   * @generated from field: map<string, ga.config_manager.casinosconfig.SettingsBranchesResponse.BranchInfo> branches = 1;
   */
  branches: { [key: string]: SettingsBranchesResponse_BranchInfo };

  /**
   * @generated from field: repeated string envs = 2;
   */
  envs: string[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.SettingsBranchesResponse.
 * Use `create(SettingsBranchesResponseSchema)` to create a new message.
 */
export const SettingsBranchesResponseSchema: GenMessage<SettingsBranchesResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 15);

/**
 * @generated from message ga.config_manager.casinosconfig.SettingsBranchesResponse.BranchInfo
 */
export type SettingsBranchesResponse_BranchInfo = Message<"ga.config_manager.casinosconfig.SettingsBranchesResponse.BranchInfo"> & {
  /**
   * @generated from field: repeated string tags = 1;
   */
  tags: string[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.SettingsBranchesResponse.BranchInfo.
 * Use `create(SettingsBranchesResponse_BranchInfoSchema)` to create a new message.
 */
export const SettingsBranchesResponse_BranchInfoSchema: GenMessage<SettingsBranchesResponse_BranchInfo> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 15, 0);

/**
 * @generated from message ga.config_manager.casinosconfig.SettingsRequest
 */
export type SettingsRequest = Message<"ga.config_manager.casinosconfig.SettingsRequest"> & {
  /**
   * require
   *
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * require
   *
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string model_branch = 3;
   */
  modelBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.SettingsRequest.
 * Use `create(SettingsRequestSchema)` to create a new message.
 */
export const SettingsRequestSchema: GenMessage<SettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 16);

/**
 * @generated from message ga.config_manager.casinosconfig.SettingsResponse
 */
export type SettingsResponse = Message<"ga.config_manager.casinosconfig.SettingsResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.CasinoModel models = 1;
   */
  models: CasinoModel[];

  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.CasinoSetting settings = 2;
   */
  settings: CasinoSetting[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.SettingsResponse.
 * Use `create(SettingsResponseSchema)` to create a new message.
 */
export const SettingsResponseSchema: GenMessage<SettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 17);

/**
 * @generated from message ga.config_manager.casinosconfig.CopySettingsBranchRequest
 */
export type CopySettingsBranchRequest = Message<"ga.config_manager.casinosconfig.CopySettingsBranchRequest"> & {
  /**
   * @generated from field: string from_branch = 2;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 3;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.CopySettingsBranchRequest.
 * Use `create(CopySettingsBranchRequestSchema)` to create a new message.
 */
export const CopySettingsBranchRequestSchema: GenMessage<CopySettingsBranchRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 18);

/**
 * @generated from message ga.config_manager.casinosconfig.CopySettingsBranchResponse
 */
export type CopySettingsBranchResponse = Message<"ga.config_manager.casinosconfig.CopySettingsBranchResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.CopySettingsBranchResponse.
 * Use `create(CopySettingsBranchResponseSchema)` to create a new message.
 */
export const CopySettingsBranchResponseSchema: GenMessage<CopySettingsBranchResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 19);

/**
 * @generated from message ga.config_manager.casinosconfig.CasinoSetting
 */
export type CasinoSetting = Message<"ga.config_manager.casinosconfig.CasinoSetting"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * @generated from field: string env = 2;
   */
  env: string;

  /**
   * @generated from field: string setting = 3;
   */
  setting: string;

  /**
   * @generated from field: string casino = 4;
   */
  casino: string;

  /**
   * @generated from field: ga.config_manager.casinosconfig.SettingType setting_type = 5;
   */
  settingType: SettingType;

  /**
   * @generated from field: string value = 6;
   */
  value: string;

  /**
   * @generated from field: string vault_path = 7;
   */
  vaultPath: string;

  /**
   * @generated from field: string vault_key = 8;
   */
  vaultKey: string;

  /**
   * @generated from field: ga.config_manager.casinosconfig.Action action = 16;
   */
  action: Action;
};

/**
 * Describes the message ga.config_manager.casinosconfig.CasinoSetting.
 * Use `create(CasinoSettingSchema)` to create a new message.
 */
export const CasinoSettingSchema: GenMessage<CasinoSetting> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 20);

/**
 * @generated from message ga.config_manager.casinosconfig.UpsertSettingsRequest
 */
export type UpsertSettingsRequest = Message<"ga.config_manager.casinosconfig.UpsertSettingsRequest"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.CasinoSetting settings = 1;
   */
  settings: CasinoSetting[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.UpsertSettingsRequest.
 * Use `create(UpsertSettingsRequestSchema)` to create a new message.
 */
export const UpsertSettingsRequestSchema: GenMessage<UpsertSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 21);

/**
 * @generated from message ga.config_manager.casinosconfig.UpsertSettingsResponse
 */
export type UpsertSettingsResponse = Message<"ga.config_manager.casinosconfig.UpsertSettingsResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.UpsertSettingsResponse.
 * Use `create(UpsertSettingsResponseSchema)` to create a new message.
 */
export const UpsertSettingsResponseSchema: GenMessage<UpsertSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 22);

/**
 * @generated from message ga.config_manager.casinosconfig.DeleteSettingsRequest
 */
export type DeleteSettingsRequest = Message<"ga.config_manager.casinosconfig.DeleteSettingsRequest"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.CasinoSetting settings = 1;
   */
  settings: CasinoSetting[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.DeleteSettingsRequest.
 * Use `create(DeleteSettingsRequestSchema)` to create a new message.
 */
export const DeleteSettingsRequestSchema: GenMessage<DeleteSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 23);

/**
 * @generated from message ga.config_manager.casinosconfig.DeleteSettingsResponse
 */
export type DeleteSettingsResponse = Message<"ga.config_manager.casinosconfig.DeleteSettingsResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.DeleteSettingsResponse.
 * Use `create(DeleteSettingsResponseSchema)` to create a new message.
 */
export const DeleteSettingsResponseSchema: GenMessage<DeleteSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 24);

/**
 * @generated from message ga.config_manager.casinosconfig.MergeSettingsRequest
 */
export type MergeSettingsRequest = Message<"ga.config_manager.casinosconfig.MergeSettingsRequest"> & {
  /**
   * @generated from field: string from_branch = 2;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 3;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.MergeSettingsRequest.
 * Use `create(MergeSettingsRequestSchema)` to create a new message.
 */
export const MergeSettingsRequestSchema: GenMessage<MergeSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 25);

/**
 * @generated from message ga.config_manager.casinosconfig.MergeSettingsResponse
 */
export type MergeSettingsResponse = Message<"ga.config_manager.casinosconfig.MergeSettingsResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinosconfig.MergeSettingsResponse.Delta deltas = 1;
   */
  deltas: MergeSettingsResponse_Delta[];

  /**
   * @generated from field: string git_branch = 2;
   */
  gitBranch: string;

  /**
   * @generated from field: string git_mr_link = 3;
   */
  gitMrLink: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.MergeSettingsResponse.
 * Use `create(MergeSettingsResponseSchema)` to create a new message.
 */
export const MergeSettingsResponseSchema: GenMessage<MergeSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 26);

/**
 * @generated from message ga.config_manager.casinosconfig.MergeSettingsResponse.Delta
 */
export type MergeSettingsResponse_Delta = Message<"ga.config_manager.casinosconfig.MergeSettingsResponse.Delta"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string setting = 2;
   */
  setting: string;

  /**
   * @generated from field: string casino = 3;
   */
  casino: string;

  /**
   * @generated from field: string value_from = 4;
   */
  valueFrom: string;

  /**
   * @generated from field: string value_to = 5;
   */
  valueTo: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.MergeSettingsResponse.Delta.
 * Use `create(MergeSettingsResponse_DeltaSchema)` to create a new message.
 */
export const MergeSettingsResponse_DeltaSchema: GenMessage<MergeSettingsResponse_Delta> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 26, 0);

/**
 * @generated from message ga.config_manager.casinosconfig.ValidateSettingsBranchRequest
 */
export type ValidateSettingsBranchRequest = Message<"ga.config_manager.casinosconfig.ValidateSettingsBranchRequest"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string model_branch = 3;
   */
  modelBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.ValidateSettingsBranchRequest.
 * Use `create(ValidateSettingsBranchRequestSchema)` to create a new message.
 */
export const ValidateSettingsBranchRequestSchema: GenMessage<ValidateSettingsBranchRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 27);

/**
 * @generated from message ga.config_manager.casinosconfig.ValidateSettingsBranchResponse
 */
export type ValidateSettingsBranchResponse = Message<"ga.config_manager.casinosconfig.ValidateSettingsBranchResponse"> & {
  /**
   * @generated from field: ga.config_manager.casinosconfig.Result res = 1;
   */
  res?: Result;
};

/**
 * Describes the message ga.config_manager.casinosconfig.ValidateSettingsBranchResponse.
 * Use `create(ValidateSettingsBranchResponseSchema)` to create a new message.
 */
export const ValidateSettingsBranchResponseSchema: GenMessage<ValidateSettingsBranchResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 28);

/**
 * @generated from message ga.config_manager.casinosconfig.ImportRequest
 */
export type ImportRequest = Message<"ga.config_manager.casinosconfig.ImportRequest"> & {
  /**
   * @generated from field: string from_git_branch = 1;
   */
  fromGitBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.ImportRequest.
 * Use `create(ImportRequestSchema)` to create a new message.
 */
export const ImportRequestSchema: GenMessage<ImportRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 29);

/**
 * @generated from message ga.config_manager.casinosconfig.ImportResponse
 */
export type ImportResponse = Message<"ga.config_manager.casinosconfig.ImportResponse"> & {
  /**
   * @generated from field: ga.config_manager.casinosconfig.Result res = 1;
   */
  res?: Result;
};

/**
 * Describes the message ga.config_manager.casinosconfig.ImportResponse.
 * Use `create(ImportResponseSchema)` to create a new message.
 */
export const ImportResponseSchema: GenMessage<ImportResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 30);

/**
 * @generated from message ga.config_manager.casinosconfig.ExportRequest
 */
export type ExportRequest = Message<"ga.config_manager.casinosconfig.ExportRequest"> & {
  /**
   * @generated from field: string from_branch = 2;
   */
  fromBranch: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.ExportRequest.
 * Use `create(ExportRequestSchema)` to create a new message.
 */
export const ExportRequestSchema: GenMessage<ExportRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 31);

/**
 * @generated from message ga.config_manager.casinosconfig.ExportResponse
 */
export type ExportResponse = Message<"ga.config_manager.casinosconfig.ExportResponse"> & {
  /**
   * @generated from field: ga.config_manager.casinosconfig.Result res = 1;
   */
  res?: Result;

  /**
   * @generated from field: string git_branch = 2;
   */
  gitBranch: string;

  /**
   * @generated from field: string git_mr_link = 3;
   */
  gitMrLink: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.ExportResponse.
 * Use `create(ExportResponseSchema)` to create a new message.
 */
export const ExportResponseSchema: GenMessage<ExportResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 32);

/**
 * @generated from message ga.config_manager.casinosconfig.SecretCheckRequest
 */
export type SecretCheckRequest = Message<"ga.config_manager.casinosconfig.SecretCheckRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;
};

/**
 * Describes the message ga.config_manager.casinosconfig.SecretCheckRequest.
 * Use `create(SecretCheckRequestSchema)` to create a new message.
 */
export const SecretCheckRequestSchema: GenMessage<SecretCheckRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 33);

/**
 * @generated from message ga.config_manager.casinosconfig.SecretCheckResponse
 */
export type SecretCheckResponse = Message<"ga.config_manager.casinosconfig.SecretCheckResponse"> & {
  /**
   * @generated from field: bool path_exist = 1;
   */
  pathExist: boolean;

  /**
   * @generated from field: bool key_exist = 2;
   */
  keyExist: boolean;
};

/**
 * Describes the message ga.config_manager.casinosconfig.SecretCheckResponse.
 * Use `create(SecretCheckResponseSchema)` to create a new message.
 */
export const SecretCheckResponseSchema: GenMessage<SecretCheckResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 34);

/**
 * @generated from message ga.config_manager.casinosconfig.SetTagsSettingsRequest
 */
export type SetTagsSettingsRequest = Message<"ga.config_manager.casinosconfig.SetTagsSettingsRequest"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[];
};

/**
 * Describes the message ga.config_manager.casinosconfig.SetTagsSettingsRequest.
 * Use `create(SetTagsSettingsRequestSchema)` to create a new message.
 */
export const SetTagsSettingsRequestSchema: GenMessage<SetTagsSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 35);

/**
 * @generated from message ga.config_manager.casinosconfig.SetTagsSettingsResponse
 */
export type SetTagsSettingsResponse = Message<"ga.config_manager.casinosconfig.SetTagsSettingsResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinosconfig.SetTagsSettingsResponse.
 * Use `create(SetTagsSettingsResponseSchema)` to create a new message.
 */
export const SetTagsSettingsResponseSchema: GenMessage<SetTagsSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinosconfig_casinos_config, 36);

/**
 * @generated from enum ga.config_manager.casinosconfig.SettingType
 */
export enum SettingType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SECRET = 1;
   */
  SECRET = 1,

  /**
   * @generated from enum value: ARRAY = 2;
   */
  ARRAY = 2,

  /**
   * @generated from enum value: STRING = 3;
   */
  STRING = 3,

  /**
   * @generated from enum value: FLOAT = 4;
   */
  FLOAT = 4,

  /**
   * @generated from enum value: INT = 5;
   */
  INT = 5,

  /**
   * @generated from enum value: BOOL = 6;
   */
  BOOL = 6,
}

/**
 * Describes the enum ga.config_manager.casinosconfig.SettingType.
 */
export const SettingTypeSchema: GenEnum<SettingType> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_casinosconfig_casinos_config, 0);

/**
 * @generated from enum ga.config_manager.casinosconfig.Action
 */
export enum Action {
  /**
   * @generated from enum value: ACTION_NO_OR_UPSET = 0;
   */
  NO_OR_UPSET = 0,

  /**
   * @generated from enum value: ACTION_DELETE = 1;
   */
  DELETE = 1,
}

/**
 * Describes the enum ga.config_manager.casinosconfig.Action.
 */
export const ActionSchema: GenEnum<Action> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_casinosconfig_casinos_config, 1);

/**
 * @generated from service ga.config_manager.casinosconfig.CasinosConfigService
 */
export const CasinosConfigService: GenService<{
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.ModelsBranches
   */
  modelsBranches: {
    methodKind: "unary";
    input: typeof ModelsBranchesRequestSchema;
    output: typeof ModelsBranchesResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.Models
   */
  models: {
    methodKind: "unary";
    input: typeof ModelsRequestSchema;
    output: typeof ModelsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.CopyModelsBranch
   */
  copyModelsBranch: {
    methodKind: "unary";
    input: typeof CopyModelsBranchRequestSchema;
    output: typeof CopyModelsBranchResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.UpsertModel
   */
  upsertModel: {
    methodKind: "unary";
    input: typeof UpsertModelRequestSchema;
    output: typeof UpsertModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.DeleteModel
   */
  deleteModel: {
    methodKind: "unary";
    input: typeof DeleteModelRequestSchema;
    output: typeof DeleteModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.MergeModelCompare
   */
  mergeModelCompare: {
    methodKind: "unary";
    input: typeof MergeModelRequestSchema;
    output: typeof MergeModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.MergeModelDo
   */
  mergeModelDo: {
    methodKind: "unary";
    input: typeof MergeModelRequestSchema;
    output: typeof MergeModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.ImportModels
   */
  importModels: {
    methodKind: "unary";
    input: typeof ImportRequestSchema;
    output: typeof ImportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.ExportModels
   */
  exportModels: {
    methodKind: "unary";
    input: typeof ExportRequestSchema;
    output: typeof ExportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.SettingsBranches
   */
  settingsBranches: {
    methodKind: "unary";
    input: typeof SettingsBranchesRequestSchema;
    output: typeof SettingsBranchesResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.Settings
   */
  settings: {
    methodKind: "unary";
    input: typeof SettingsRequestSchema;
    output: typeof SettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.CopySettingsBranch
   */
  copySettingsBranch: {
    methodKind: "unary";
    input: typeof CopySettingsBranchRequestSchema;
    output: typeof CopySettingsBranchResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.UpsertSettings
   */
  upsertSettings: {
    methodKind: "unary";
    input: typeof UpsertSettingsRequestSchema;
    output: typeof UpsertSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.DeleteSettings
   */
  deleteSettings: {
    methodKind: "unary";
    input: typeof DeleteSettingsRequestSchema;
    output: typeof DeleteSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.MergeSettingsCompare
   */
  mergeSettingsCompare: {
    methodKind: "unary";
    input: typeof MergeSettingsRequestSchema;
    output: typeof MergeSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.MergeSettingsDo
   */
  mergeSettingsDo: {
    methodKind: "unary";
    input: typeof MergeSettingsRequestSchema;
    output: typeof MergeSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.ValidateSettingsBranch
   */
  validateSettingsBranch: {
    methodKind: "unary";
    input: typeof ValidateSettingsBranchRequestSchema;
    output: typeof ValidateSettingsBranchResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.ImportSettings
   */
  importSettings: {
    methodKind: "unary";
    input: typeof ImportRequestSchema;
    output: typeof ImportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.ExportSettings
   */
  exportSettings: {
    methodKind: "unary";
    input: typeof ExportRequestSchema;
    output: typeof ExportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.SetTagsSettings
   */
  setTagsSettings: {
    methodKind: "unary";
    input: typeof SetTagsSettingsRequestSchema;
    output: typeof SetTagsSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.SecretCheck
   */
  secretCheck: {
    methodKind: "unary";
    input: typeof SecretCheckRequestSchema;
    output: typeof SecretCheckResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinosconfig.CasinosConfigService.SecretCheckAndCreate
   */
  secretCheckAndCreate: {
    methodKind: "unary";
    input: typeof SecretCheckRequestSchema;
    output: typeof SecretCheckResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_casinosconfig_casinos_config, 0);

